export default __webpack_public_path__ + "static/media/11_Backyard-adventure_Share.094e71f8.jpg";